export const formatNumber = (value: number | string | boolean) =>
    value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");